import {MAIN} from './Consts';
import request from 'superagent';

const header = {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json; charset=utf-8'
}

const headerWithToken = {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json; charset=utf-8'
}

export default class REST {

    static login(username, password) {
        let body = {
            'username': username, 'password': password
        };
        return fetch(MAIN.API.LOGIN, {
            method: 'post',
            headers: header,
            body: JSON.stringify(body)
        }).then(res => res.json());
    }

    static logout() {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.LOGOUT, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static authWithToken() {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.TOKEN, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static getVersion() {
        return fetch(MAIN.API.VERSION, {
            method: 'get'
        }).then(res => res.json());
    }

    static requestAccount(object) {
        return fetch(MAIN.API.REQUEST_ACCOUNT, {
            method: 'post',
            headers: header,
            body: JSON.stringify(object)
        }).then(res => res.json());
    }

    static requestHelp(object) {
        return fetch(MAIN.API.REQUEST_HELP, {
            method: 'post',
            headers: header,
            body: JSON.stringify(object)
        }).then(res => res.json());
    }

    static classList() {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_CLASS_LIST, {
            method: 'get',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static teacherClassList(teacherId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_TEACHER_CLASS_LIST + '?teacherId=' + teacherId, {
            method: 'get',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listExternalTeacher(body) {
        headerWithToken['token'] = localStorage.getItem('token');
        let url = MAIN.API.LIST_EXTERNAL_TEACHER + '?userId=' + body.teacherId + '&firstname=' + body.firstName + '&lastname=' + body.lastName;
        return fetch(url, {headers: headerWithToken}).then(res => res.json());
    }

    static addNewClass(data) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.ADD_NEW_CLASS, {
            method: 'post',
            headers: headerWithToken,
            body: JSON.stringify(data)
        }).then(res => res.json());
    }

    static deleteClass(object) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.DELETE_CLASS + '?classId=' + object, {
            method: 'delete',
            headers: headerWithToken,
        }).then(res => res.json());
    }

    static updateClass(body) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.UPDATE_CLASS, {
            method: 'put',
            headers: headerWithToken,
            body: JSON.stringify(body)
        }).then(res => res.json());
    }

    static listStudents(id) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.LIST_STUDENTS + '?classId=' + id, {
            headers: headerWithToken,
        }).then(res => res.json());
    }

    static addNewStudent(classId, object) {
        let students = [];
        students.push(object);
        let body = {classId: classId, students: students};
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.ADD_NEW_STUDENT, {
            method: 'post',
            headers: headerWithToken,
            body: JSON.stringify(body)
        }).then(res => res.json());
    }

    static updateStudent(student) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.UPDATE_STUDENT, {
            method: 'put',
            headers: headerWithToken,
            body: JSON.stringify(student)
        }).then(res => res);
    }

    static transferStudent(body) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.TRANSFER_STUDENT, {
            method: 'post',
            headers: headerWithToken,
            body: JSON.stringify(body)
        }).then(res => res.json);
    }

    static transferMultipleStudents(body) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.TRANSFER_MULTIPLE_STUDENT, {
            method: 'post',
            headers: headerWithToken,
            body: JSON.stringify(body)
        }).then(res => res.json);
    }

    static deleteStudent(id,classId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.DELETE_STUDENT + '?userId=' + id+"&classId="+classId, {
            method: 'delete',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listTeachers() {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.LIST_TEACHERS, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listTeachersInSchool(schoolId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.LIST_TEACHERS_IN_SCHOOL+ '?schoolId=' + schoolId, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static createTeacher(body) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.CREATE_TEACHER, {
            method: 'post',
            headers: headerWithToken,
            body: JSON.stringify(body)
        }).then(res => res.json());
    }

    static updateTeacher(body) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.UPDATE_TEACHER, {
            method: 'put',
            headers: headerWithToken,
            body: JSON.stringify(body)
        }).then(res => res.json());
    }

    static deleteTeacher(id) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.DELETE_TEACHER + '?userId=' + id, {
            method: 'delete',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listSchoolAdmins() {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.LIST_SCHOOLADMINS, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static createSchoolAdmin(body) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.CREATE_SCHOOLADMIN, {
            method: 'post',
            headers: headerWithToken,
            body: JSON.stringify(body)
        }).then(res => res.json());
    }

    static updateSchoolAdmin(body) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.UPDATE_SCHOOLADMIN, {
            method: 'put',
            headers: headerWithToken,
            body: JSON.stringify(body)
        }).then(res => res.json());
    }

    static deleteSchoolAdmin(id) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.DELETE_SCHOOLADMIN + '?userId=' + id, {
            method: 'delete',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listWordMarkScore(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.LIST_WORDMARK_SCORE + '?userId=' + userId, {
            method: 'get',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listWordMark2Score(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.LIST_WORDMARK2_SCORE + '?userId=' + userId, {
            method: 'get',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listKidSpeakScore(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_KIDSPEAK_SCORE_LIST + '?userId=' + userId, {
            method: 'get',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listPictureNamingScores(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_PICTURENAMING_SCORE_LIST + '?userId=' + userId, {
            method: 'get',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listWordSignSayScores(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_WORDSIGNSAY_SCORE_LIST + '?userId=' + userId, {
            method: 'get',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listCopyRightScores(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_COPYRIGHT_SCORE_LIST + '?userId=' + userId, {
            method: 'get',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listKidSignScores(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_KIDSIGN_SCORE_LIST + '?userId=' + userId, {
            method: 'get',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listMazeScoreData(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.LIST_MAZE_SCORE_DATA + '?userId=' + userId, {
            method: 'get',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static getMazeScoreCount() {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_MAZE_SCORE_COUNT, {
            method: 'get',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static getMazeRandom() {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.LIST_RANDOM_MAZE, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listSlashTestScoreData(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.LIST_SLASH_SCORE_DATA + '?userId=' + userId, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static getSlashScoreCount() {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_SLASH_SCORE_COUNT, {
            method: 'get',
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listWorkMarkScoreData(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_WORDMARK_SCORE_DATA + '?userId=' + userId, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listWorkMark2ScoreData(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_WORDMARK2_SCORE_DATA + '?userId=' + userId, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listKidSpeakScoreData(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_KIDSPEAK_DATA + '?userId=' + userId, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listPictureNamingData(userId, PNModel) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_PICTURENAMING_DATA + '?userId=' + userId+ '&PNModel=' + PNModel, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listCopyRightData(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_COPYRIGHT_DATA + '?userId=' + userId, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listWordSignSayData(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_WORDSIGNSAY_DATA + '?userId=' + userId, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listKidSignData(userId) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.GET_KIDSIGN_DATA + '?userId=' + userId, {
            headers: headerWithToken
        }).then(res => res.json());
    }

    static listRandomPNPictures() {
        return request.get(MAIN.API.GET_PICTURENAMING_RANDOM)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static uploadPNVideo(fileStream, data, blob) {
        if(blob){
            let jBlob = new Blob([JSON.stringify(data)], {type : 'application/json'});
            return request.post(MAIN.API.UPLOAD_PICTURENAMING_FILE)
                .attach("file", blob)
                .attach("file2",jBlob)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        } else if (fileStream && !blob) {
            return request.post(MAIN.API.UPLOAD_PICTURENAMING_FILE)
                .attach("file", data)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        } else {
            return request.post(MAIN.API.UPLOAD_PICTURENAMING_FILE)
                .send(data)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        }
    }

    static insertPNSession(data) {
        return request.post(MAIN.API.ADD_PICTURENAMING_SESSION)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static getBestScores() {
        return request.get(MAIN.API.GET_STUDENT_BEST_SCORE)
            .set("token", localStorage.getItem('token'))
            .then(res => res.body);
    }

    static updateMazeScore(data) {
        return request.put(MAIN.API.UPDATE_MAZE_SCORE)
            .send(data)
            .set("token", localStorage.getItem('token'))
            .then(res => res.body);
    }

    static postMazeSession(data) {
        return request.post(MAIN.API.POST_MAZE_SESSION)
            .send(data)
            .set("token", localStorage.getItem('token'))
            .then(res => res.body);
    }

    static createMazeContent(data) {
        return request.post(MAIN.API.CREATE_MAZE_CONTENT)
            .send(data)
            .set("token", localStorage.getItem('token'))
            .then(res => res.body);
    }

    static getStudentBestScores(userId) {
        return request.get(MAIN.API.GET_USER_BESTSCORES+"?userId="+userId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static createPN1On1Session(data) {
        return request.post(MAIN.API.ADD_PICTURENAMING_1ON1)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static getPNManualSession(testId) {
        return request.get(MAIN.API.GET_PICTURENAMING_SESSION + "?testId=" + testId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static gradePNSession(data) {
        return request.put(MAIN.API.UPDATE_PICTURENAMING_GRADE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static gradePNManualSession(data) {
        return request.post(MAIN.API.PICTURENAMING_MANUAL_GRADE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static getPNManualScore(testId) {
        return request.get(MAIN.API.GET_PICTURENAMING_MANUAL_SCORE + "?testId=" + testId)
            .set('token', localStorage.getItem('token'))
            .then(res => res.body);
    }

    static getSlashTestRandom() {
        return request.get(MAIN.API.LIST_RANDOM_SLASH)
            .set('token', localStorage.getItem('token'))
            .then(res => res.body);
    }

    static postSlashSession(body) {
        return request.post(MAIN.API.POST_SLASH_SESSION)
            .send(body)
            .set('token', localStorage.getItem('token'))
            .then(res => res.body);
    }

    static updateSlashScores(body) {
        return request.put(MAIN.API.UPDATE_SLASH_SCORE)
            .send(body)
            .set('token', localStorage.getItem('token'))
            .then(res => res.body);
    }

    static getKSRandom() {
        return request.get(MAIN.API.GET_KIDSPEAK_RANDOM)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static uploadKSAudio(blob) {
        return request.post(MAIN.API.UPLOAD_KIDSPEAK_FILE)
            .attach("file", blob)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static insertKSSession(data) {
        return request.post(MAIN.API.ADD_KIDSPEAK_SESSION)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static getKSSession(testId) {
        return request.get(MAIN.API.GET_KIDSPEAK_SESSION + "?testId=" + testId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static gradeKSSession(data) {
        return request.put(MAIN.API.UPDATE_KIDSPEAK_GRADE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static updateKSBestScore(data) {
        return request.put(MAIN.API.UPDATE_KIDSPEAK_BEST_SCORE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static getWordMarkRandom() {
        return request.get(MAIN.API.LIST_RANDOM_WORDMARK)
            .set('token', localStorage.getItem('token'))
            .then(res => res.body);
    }

    static getWordMark2Random1() {
        return request.get(MAIN.API.LIST_RANDOM1_WORDMARK2)
            .set('token', localStorage.getItem('token'))
            .then(res => res.body);
    }

    static getWordMark2Random2() {
        return request.get(MAIN.API.LIST_RANDOM2_WORDMARK2)
            .set('token', localStorage.getItem('token'))
            .then(res => res.body);
    }

    static postWordMarkSession(body) {
        return request.post(MAIN.API.POST_WORDMARK_SESSION)
            .set('token', localStorage.getItem('token'))
            .send(body)
            .then(res => res.body);
    }

    static postWordMark2Session(body) {
        return request.post(MAIN.API.POST_WORDMARK2_SESSION)
            .set('token', localStorage.getItem('token'))
            .send(body)
            .then(res => res.body);
    }

    static getWordMarkSession(testId) {
        return request.get(MAIN.API.GET_WORDMARK_SESSION + '?testId=' + testId)
            .set('token', localStorage.getItem('token'))
            .then(res => res.body);
    }

    static getWordMark2Session(testId) {
        return request.get(MAIN.API.GET_WORDMARK2_SESSION + '?testId=' + testId)
            .set('token', localStorage.getItem('token'))
            .then(res => res.body);
    }

    static gradeWordMarkSession(data) {
        return request.put(MAIN.API.UPDATE_WORDMARK_GRADE)
            .set('token', localStorage.getItem('token'))
            .send(data)
            .then(res => res.body);
    }

    static gradeWordMark2Session(data) {
        return request.put(MAIN.API.UPDATE_WORDMARK2_GRADE)
            .set('token', localStorage.getItem('token'))
            .send(data)
            .then(res => res.body);
    }

    static updateMazeNote(data) {
        return request.put(MAIN.API.UPDATE_MAZE_SCORE_NOTE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static updateSlashNote(data) {
        return request.put(MAIN.API.UPDATE_SLASH_SCORE_NOTE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static updatePNNote(data) {
        return request.put(MAIN.API.UPDATE_PICTURENAMING_SCORE_NOTE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static updatePNBestScore(data) {
        return request.put(MAIN.API.UPDATE_PICTURENAMING_BEST_SCORE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static updateWordMarkNote(data) {
        return request.put(MAIN.API.UPDATE_WORDMARK_SCORE_NOTE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static updateWordMark2Note(data) {
        return request.put(MAIN.API.UPDATE_WORDMARK2_SCORE_NOTE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static updateKidSpeakNote(data) {
        return request.put(MAIN.API.UPDATE_KIDSPEAK_SCORE_NOTE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static getCRRandom() {
        return request.get(MAIN.API.GET_COPYRIGHT_RANDOM)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static uploadCRVideo(fileStream, data) {
        if (fileStream) {
            return request.post(MAIN.API.UPLOAD_COPYRIGHT_FILE)
                .attach("file", data)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        } else {
            return request.post(MAIN.API.UPLOAD_COPYRIGHT_FILE)
                .send(data)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        }
    }

    static insertCRSession(data) {
        return request.post(MAIN.API.ADD_COPYRIGHT_SESSION)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static getCRSession(testId) {
        return request.get(MAIN.API.GET_COPYRIGHT_SESSION + "?testId=" + testId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static gradeCRSession(data) {
        return request.put(MAIN.API.UPDATE_COPYRIGHT_GRADE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static updateCRBestScore(data) {
        return request.put(MAIN.API.UPDATE_COPYRIGHT_BEST_SCORE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static updateCopyRightNote(data) {
        return request.put(MAIN.API.UPDATE_COPYRIGHT_SCORE_NOTE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }


    static getWSSRandom() {
        return request.get(MAIN.API.GET_WORDSIGNSAY_RANDOM)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static uploadWSSVideo(fileStream, data, blob) {
        if(blob){
            let jBlob = new Blob([JSON.stringify(data)], {type : 'application/json'});
            return request.post(MAIN.API.UPLOAD_WORDSIGNSAY_FILE)
                .attach("file", blob)
                .attach("file2",jBlob)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        } else if (fileStream && !blob) {
            return request.post(MAIN.API.UPLOAD_WORDSIGNSAY_FILE)
                .attach("file", data)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        } else {
            return request.post(MAIN.API.UPLOAD_WORDSIGNSAY_FILE)
                .send(data)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        }
    }

    static insertWSSSession(data) {
        return request.post(MAIN.API.ADD_WORDSIGNSAY_SESSION)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }



    static getWSSSession(testId) {
        return request.get(MAIN.API.GET_WORDSIGNSAY_SESSION + "?testId=" + testId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static gradeWSSSession(data) {
        return request.put(MAIN.API.UPDATE_WORDSIGNSAY_GRADE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static updateWSSBestScore(data) {
        return request.put(MAIN.API.UPDATE_WORDSIGNSAY_BEST_SCORE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static updateWordSignSayNote(data) {
        return request.put(MAIN.API.UPDATE_WORDSIGNSAY_SCORE_NOTE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }


    static getKSSRandom() {
        return request.get(MAIN.API.GET_KIDSIGN_RANDOM)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static uploadKSSVideo(fileStream, data, blob) {
        if(blob){
            let jBlob = new Blob([JSON.stringify(data)], {type : 'application/json'});
            return request.post(MAIN.API.UPLOAD_KIDSIGN_FILE)
                .attach("file", blob)
                .attach("file2",jBlob)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        } else if (fileStream && !blob) {
            return request.post(MAIN.API.UPLOAD_KIDSIGN_FILE)
                .attach("file", data)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        } else {
            return request.post(MAIN.API.UPLOAD_KIDSIGN_FILE)
                .send(data)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        }
    }

    static insertKSSSession(data) {
        return request.post(MAIN.API.ADD_KIDSIGN_SESSION)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static getKSSSession(testId) {
        return request.get(MAIN.API.GET_KIDSIGN_SESSION + "?testId=" + testId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static gradeKSSSession(data) {
        return request.put(MAIN.API.UPDATE_KIDSIGN_GRADE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static updateKSSBestScore(data) {
        return request.put(MAIN.API.UPDATE_KIDSIGN_BEST_SCORE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static updateKidSignNote(data) {
        return request.put(MAIN.API.UPDATE_KIDSIGN_SCORE_NOTE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }


    static resetUsername(data) {
        return request.post(MAIN.API.RESET_USERNAME)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static resetPassword(data) {
        return request.post(MAIN.API.RESET_PASSWORD)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static changePassword(data) {
        return request.post(MAIN.API.CHANGE_PASSWORD)
            .send(data)
            .then(res => res.body);
    }

    static accountRequest(data) {
        return request.post(MAIN.API.REQUEST_ACCOUNT)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static helpRequest(data) {
        return request.post(MAIN.API.REQUEST_HELP)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static getStudentAppStatus(studentId) {
        if(studentId){
            return request.get(MAIN.API.GET_STUDENT_APPS_STATUS+"?studentId=" + studentId)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        }else{
            return request.get(MAIN.API.GET_STUDENT_APPS_STATUS)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        }
    }

    static getUngradedTasks(appName) {
        return request.get(MAIN.API.GET_UNGRADED_TASKS+"?aveAppName=" + appName)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static getParentStudents(){
        return request.get(MAIN.API.GET_PARENT_STUDENTS)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static deleteParent(studentId){
        request.delete(MAIN.API.DELETE_PARENT + "?studentId=" + studentId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static checkStudentData(userId, appName) {
        return request.get(MAIN.API.CHECK_STUDENT_DATA+ "?userId=" + userId + "&appName=" + appName)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static getSurveyAmount(userId, appName) {
        return request.get(MAIN.API.GET_SURVEY_AMOUNT+ "?userId=" + userId + "&appName=" + appName)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static checkSurveyHomePage(userId) {
        return request.get(MAIN.API.CHECK_SURVEY_HOMEPAGE+ "?userId=" + userId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static checkTeacherLogin(userId) {
        return request.get(MAIN.API.CHECK_TEACHER_LOGIN+ "?userId=" + userId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static checkTeacherResources(userId) {
        return request.get(MAIN.API.CHECK_TEACHER_RESOURCES+ "?userId=" + userId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static checkTeacherDataChart(userId, appName) {
        return request.get(MAIN.API.CHECK_TEACHER_DATA_CHART+ "?userId=" + userId + '&appName=' + appName)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static checkTeacherGrading(userId, appName) {
        return request.get(MAIN.API.CHECK_TEACHER_GRADING+ "?userId=" + userId + '&appName=' + appName)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static getStudentNotifications() {
        return request.get(MAIN.API.STUDENT_NOTIFICATIONS)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static deletePictureNamingScore(testId) {
        return request.delete(MAIN.API.DELETE_PICTURENAMING_SCORE + "?assessmentId=" + testId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static deleteWordMarkScore(testId) {
        return request.delete(MAIN.API.DELETE_WORDMARK_SCORE + "?assessmentId=" + testId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static deleteWordMark2Score(testId) {
        return request.delete(MAIN.API.DELETE_WORDMARK2_SCORE + "?assessmentId=" + testId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static deleteWordSignSayScore(testId) {
        return request.delete(MAIN.API.DELETE_WORDSIGNSAY_SCORE + "?assessmentId=" + testId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static deleteKidSpeakScore(testId) {
        return request.delete(MAIN.API.DELETE_KIDSPEAK_SCORE + "?assessmentId=" + testId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static deleteKidSignScore(testId) {
        return request.delete(MAIN.API.DELETE_KIDSIGN_SCORE + "?assessmentId=" + testId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static deleteCopyRightScore(testId) {
        return request.delete(MAIN.API.DELETE_COPYRIGHT_SCORE + "?assessmentId=" + testId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static listMazePassages() {
        return request.get(MAIN.API.List_MAZE_PASSAGE)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static addMazePassage(data) {
        return request.post(MAIN.API.ADD_MAZE_PASSAGE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }
    static deleteMazePassage(passageId) {
        return request.delete(MAIN.API.DELETE_MAZE_PASSAGE + "?passageId=" + passageId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }
    static updateMazePassage(data) {
        return request.put(MAIN.API.UPDATE_MAZE_PASSAGE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }
    static activateMazePassage(passageId) {
        return request.get(MAIN.API.ACTIVEATE_MAZE_PASSAGE + "?passageId=" + passageId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static listKidSpeakPassages() {
        return request.get(MAIN.API.List_KIDSPEAK_PASSAGE)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }
    static listKidSpeakPassagesByUId(uId) {
        return request.get(MAIN.API.List_KIDSPEAK_PASSAGE_BY_UID + "?uId=" + uId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static addKidSpeakPassage(data) {
        return request.post(MAIN.API.ADD_KIDSPEAK_PASSAGE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }
    static deleteKidSpeakPassage(passageId) {
        return request.delete(MAIN.API.DELETE_KIDSPEAK_PASSAGE + "?passageId=" + passageId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }
    static updateKidSpeakPassage(data) {
        return request.put(MAIN.API.UPDATE_KIDSPEAK_PASSAGE)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }
    static activateKidSpeakPassage(passageId) {
        return request.get(MAIN.API.ACTIVEATE_KIDSPEAK_PASSAGE + "?passageId=" + passageId)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static reportBug(data) {
        return request.post(MAIN.API.REPORT_BUG)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static teacherConsent(data) {
        return request.post(MAIN.API.TEACHER_CONSENT)
            .send(data)
            .set("token", localStorage.getItem("token"))
            .then(res => res.body);
    }

    static addAnalytics(data) {
        if (localStorage.getItem("token")) {
            return request.post(MAIN.API.ADD_ANALYTICS)
                .send(data)
                .set("token", localStorage.getItem("token"))
                .then(res => res.body);
        }else{
            return request.post(MAIN.API.ADD_ANALYTICS_NONUSER)
                .send(data)
                .then(res => res.body);
        }
    }

    static listSchools() {
        return request.get(MAIN.API.LIST_SCHOOLS)
            .then(res => res.body);
    }

    static listAdminSchools(id) {
        headerWithToken['token'] = localStorage.getItem('token');
        return fetch(MAIN.API.LIST_ADMIN_SCHOOLS + '?userId=' + id, {
            headers: headerWithToken,
        }).then(res => res.json());
    }

    static createSchool(data) {
        return request.post(MAIN.API.CREATE_SCHOOL)
            .send(data)
            .then(res => res.body);
    }
}




// WEBPACK FOOTER //
// ./src/Shared/REST.js